import { AttachmentCommonUpload, EventHandler, Label, OutlineButton, PopupDialogbox, Tooltip } from "client/CommonComponents";
import { CONSTANTS } from "client/utils/constants";
import '../TaskBulkOrder.scss'
import { isAuthorized } from "client/utils/Permissions";
import { FLEET_PROCESSING_PERMISSIONS } from "client/utils/constants/fleetProcessingPermissions";
import Completed from "../../../../../assets/images/PenndingApproval/Approved.svg";
import Cancelled from "../../../../../assets/images/MyOrders/Cancelled.svg";
import CancelConfirmationPopup from "client/CommonComponents/DialogBox/CancelConfirmationPopup";

const TaskBulkOrderHeader = (props?: any) => {
    const {
        item,
        iconReturn,
        list,
        uploadedList,
        setList,
        onUploadClick,
        attachmentError,
        setAttachmentError,
        onRemoveClick,
        handleItemCancelClick,
        purchaseOrderStepperData,
        Popupcontent,
        hideConfirmationDialog
    } = props
    
    return (<div className={`bulkOrder-taskAccordionHeaderBlock ${(item?.fleetStatus != CONSTANTS.ITEM_STATUS.REQUISITION_COMPLETE && item?.fleetStatus != CONSTANTS.ITEM_STATUS.CANCELLED) ? 'cancel-fleetbulkorder' :''}`}>
        <div>
            <Label data-attribute="TaskBulkOrderHeader_Default_Label">Item ID</Label>
            <Tooltip content={`${item?.itemId}`} data-attribute="TaskBulkOrderHeader_Default_Tooltip">
                <span className="dateContent">{item?.itemId || "-"}</span>
            </Tooltip>
        </div>
        <div>
            <Label data-attribute="TaskBulkOrderHeader_Default_Label_2">Asset #</Label>
            <Tooltip content={`${item?.assetNumber || "-"}`} data-attribute="TaskBulkOrderHeader_Default_Tooltip_2">
                <span className="dateContent">{item?.assetNumber || "-"}</span>
            </Tooltip>
        </div>
        <div>
            <Label data-attribute="TaskBulkOrderHeader_Default_Label_3">PO #</Label>
            <Tooltip content={`${item?.poNumber || "-"}`} data-attribute="TaskBulkOrderHeader_Default_Tooltip_3">
                <span className="dateContent">{item?.poNumber || "-"}</span>
            </Tooltip>
        </div>
        <div>
            <Label data-attribute="TaskBulkOrderHeader_Default_Label_4">Item Status</Label>
            <Tooltip content={`${item?.itemStatus}`} data-attribute="TaskBulkOrderHeader_Default_Tooltip_4">
                <p className="fleetValue">
                    <span>{iconReturn(item?.itemStatus)}</span>
                    <span>{item?.itemStatus || "-"}</span>
                </p>
            </Tooltip>
        </div>
        <div>
            <Label data-attribute="TaskBulkOrderHeader_Default_Label_5">Fleet Status</Label>
            <Tooltip content={`${item?.fleetStatus}`} data-attribute="TaskBulkOrderHeader_Default_Tooltip_5">
                <p className="fleetValue">
                    <span>{iconReturn(item?.fleetStatus)}</span>
                    <span>{item?.fleetStatus || "-"}</span>
                </p>
            </Tooltip>
        </div>
        <div>
            {item.fleetStatus == CONSTANTS.ORDER_STATUS.REQUISITION_COMPLETE ? (
                <img
                    src={Completed}
                    alt="status"
                    title="status"
                    className="me-1"
                />
            ) : null}
            {
                item.fleetStatus == CONSTANTS.ORDER_STATUS.CANCELLED ? (
                    <img
                        src={Cancelled}
                        alt="status"
                        title="status"
                        className="me-1 cancelFleetIcon"
                    />
                ) : null
            }

        </div>
        {(item?.fleetStatus != CONSTANTS.ITEM_STATUS.REQUISITION_COMPLETE && item?.fleetStatus != CONSTANTS.ITEM_STATUS.CANCELLED) ?
            <EventHandler onEvent={(e: any) => e.stopPropagation()} data-attribute="TaskBulkOrderHeader_Default_EventHandler">
                <div className="cancel-bulkfleetorder-btn">
                    <OutlineButton
                        text='Cancel Item'
                        title='Cancel Item'
                        onClick={(e: any) => handleItemCancelClick(e, item.fleetDetailId)}
                        disabled={!isAuthorized(FLEET_PROCESSING_PERMISSIONS?.DELETE_PURCHASEORDERS)}
                     data-attribute="TaskBulkOrderHeader_Cancel_Item_Button" />
                </div>
            </EventHandler> : null}
        <EventHandler onEvent={(e: any) => e.stopPropagation()} data-attribute="TaskBulkOrderHeader_Default_EventHandler_2">
            <div className='attachment-bulkorder-fleet header-attachment mt-2'>
                <AttachmentCommonUpload
                    link={true}
                    list={list}
                    uploadedList={uploadedList}
                    setList={setList}
                    multiple={true}
                    uploadBtnClick={onUploadClick}
                    error={attachmentError}
                    setError={setAttachmentError}
                    maxSize={5}
                    onRemove={onRemoveClick}
                    tooltipConent={CONSTANTS.ATTACHMENTS_TOOLTIP_CONTENT}
                    iAttachmentEditable={true}
                    isDownloadable = {true}
                    targetId={`attachements-${item?.fleetDetailId?.toString()}`}
                    isChangesBeingTracked={false}
                    disabled={(item?.fleetStatus == CONSTANTS.ITEM_STATUS.REQUISITION_COMPLETE || item?.fleetStatus == CONSTANTS.ITEM_STATUS.CANCELLED || !(isAuthorized(FLEET_PROCESSING_PERMISSIONS?.EDIT_FLEET_ADMIN_TASKS) || isAuthorized(FLEET_PROCESSING_PERMISSIONS?.UPDATE_FLEET_ADMIN_TASKS)))}
                 data-attribute="TaskBulkOrderHeader_Default_AttachmentCommonUpload" />
            </div>
        </EventHandler>
        {
        Popupcontent.isDialogVisible && (
          <PopupDialogbox
            hideDialog={!Popupcontent.isDialogVisible}
            onDismiss={hideConfirmationDialog}
            Popupcontent={Popupcontent}
            popupOutlinebtnOnclick={() => Popupcontent?.popupOutlinebtnOnclick()}
            popupPrimarybtnOnclick={(
                item: any,
                actionby: string,
                value: any) => Popupcontent?.popupPrimarybtnOnclick(item,
                  actionby,
                  value)}
           data-attribute="TaskBulkOrderHeader_Default_PopupDilalogBox" />
        )
      }
    </div>)
}

export default TaskBulkOrderHeader;